export default "__VITE_ASSET__SFvsRm6i__"